import React from 'react';
import { useSurveyContext } from 'Views/Onboarding/Pages/Survey/SurveyContext';
import RedirectToDashboard from './RedirectToDashboard';
import SurveyContent from './SurveyContent';

const SurveyContentPicker = (props) => {
  const { onboardingStepCollection } = useSurveyContext();

  if (onboardingStepCollection) {
    return (
      <SurveyContent {...props} />
    );
  }

  return (
    <RedirectToDashboard {...props} />
  );
};

export default SurveyContentPicker;
